import sectionsRef from "@models/interactions/sections-ref";
import LegalLayout from "@components/templates/legal-layout";


export default function ProgramTerms() {
  const { model, operations } = sectionsRef(15);

  return (
    <LegalLayout>
      <main className="w-full flex flex-col text-white px-4 max-w-[1010px] mt-[60px] pb-5">
        <h2 className=" text-white text-center font-semibold text-4xl">CORE PROGRAM TERMS OF USE</h2>
        <span className=" text-white text-center mt-4">WELCOME TO MEMO’D’S CORE PROGRAM (“CORE PROGRAM”)!</span>
        <article className=" text-white text-left mt-4">
          PLEASE READ THE FOLLOWING TERMS AND CONDITIONS (“<strong>CORE PROGRAM TERMS</strong> ”) CAREFULLY. BY PARTICIPATING IN THE CORE PROGRAM,
          YOU (ANY PARTICIPATING INDIVIDUAL OR ENTITY IN THE CORE PROGRAM IS REFERRED TO AS <strong>“YOU,”</strong> <strong>“YOUR,”</strong> OR<strong> “CORE CREATOR”</strong >)
          HEREBY ACCEPT AND AGREE TO BE LEGALLY BOUND BY THESE TERMS AND ALL TERMS INCORPORATED HEREIN BY REFERENCE. 
          IT IS YOUR RESPONSIBILITY TO READ THE TERMS BEFORE PROCEEDING TO PARTICIPATE IN THE CORE PROGRAM, INCLUDING BUT NOT 
          LIMITED TO ALL FEATURES, SITES, AND CONTENT.
        </article>
        <div className="flex flex-col text-white mt-10 gap-2 text-xl">
          <span>
            1.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[0]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ACCEPTANCE OF TERMS
            </a>
          </span>
          <span>
            2.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[1]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ELIGIBILITY
            </a>
          </span>
          <span>
            3.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[2]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              CORE PROGRAM
            </a>
          </span>
          <span>
            4.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[3]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              PAYMENT
            </a>
          </span>
          <span>
            5.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[4]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              INTELLECTUAL PROPERTY
            </a>
          </span>
          <span>
            6.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[5]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              TERMINATION
            </a>
          </span>
          <span>
            7.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[6]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              PARTIES’ RELATIONSHIP
            </a>
          </span>
          <span>
            8.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[7]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              COMMUNICATIONS
            </a>
          </span>
          <span>
            9.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[8]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              CONFIDENTIALITY
            </a>
          </span>
          <span>
            10.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[9]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              .REPRESENTATIONS AND WARRANTIES
            </a>
          </span>
          <span>
            11.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[10]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ACCOUNT SUSPENSION/TERMINATION; FORFEITURE; WITHDRAWAL.
            </a>
          </span>
          <span>
            12.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[11]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              DISCLAIMER
            </a>
          </span>
          <span>
            13.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[12]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              LIMITATION OF LIABILITY
            </a>
          </span>
          <span>
            14.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[13]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              ASSIGNMENT
            </a>
          </span>
          <span>
            15.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[14]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              GENERAL
            </a>
          </span>
        </div>

        <article className="flex w-full flex-col justify-start gap-[18px] lg:w-[916px] text-white mt-4">
          <section ref={model.refs[0]} className="flex flex-col gap-[18px] ">
            <span className="flex flex-col gap-[18px] ml-12">
              <strong>1. ACCEPTANCE OF TERMS</strong>
              <p className="ml-3">
                The following Core Program Terms govern Your participation in the Core Program
                on the Memo’d Platform. The Core Program Terms are subject to, and will also include,
                the Memo’d Terms of Service, Privacy Policy, and all other Memo’d policies and
                guidelines, each as may be updated or amended from time to time (together, the “<strong>Policies</strong>”).
                In the case of any inconsistency between these Core Program Terms and the Policies, insofaras they relate to the Core Program, these Core Program Terms will prevail. Upon expiration or
                termination of the Core Program or Core Creator’s participation in the Core Program, the Policies
                will remain in effect and continue to apply to Your use of the Platform. Any capitalized terms
                used but not defined herein has the respective meanings given to them in the Policies.
              </p>
            </span>
          </section>
          <section ref={model.refs[1]} className="flex flex-col gap-[18px]">
            <span className="flex flex-col gap-[18px] ml-12">
              <strong>
                2. ELIGIBILITY
              </strong>
              <p  className="ml-3"><strong>2.1 Invitation.</strong>Memo’d will select certain Creators to participate in the Core Program,
                which provides access to certain Core Program Benefits (as described below).
              </p>
              <p className="ml-3"><strong>2.2 Age Requirements.</strong>
                By participating in the Program, you agree to be bound by these Terms as a legal agreement. 
                You must be at least 13 years old to participate in the Programs.
              </p>
              <p className="ml-3"><strong> 2.3 Permission.</strong>
                If You are under 18 years old, You represent that You have Your
                parent or guardian’s permission to participate in the Programs. Please have them read
                these Core Program Terms with You. If You are a parent or guardian of a Creator under
                the age of 18, by allowing your child to participate in the Core Program, you are 
                subject to these Core Program Terms and responsible for your child’s activity in the
                Core Program.
              </p>
              <p className="ml-3"><strong> 2.4 Businesses.</strong> 
                If You are using the Core Program on behalf of a company or organization,
                You represent that You have the authority to act on behalf of that entity, and that such entity
                accepts these Core Program Terms.
              </p>

              <p className="ml-3"><strong>2.5 Memo’d Account.</strong> You must have an active Memo'd account 
                in good standing and in compliance with Memo'd's Policies.
              </p>
              <p className="ml-3"><strong>2.6 Payment Setup</strong> You must provide at least one valid linked
                digital payment account that can be used as a payment method through the Core Program, and complete 
                all necessary onboarding documentation (including, without limitation, any tax
                reporting documents required by Memo'd or the payment account provider).
              </p>
            </span>
          </section>
          <section ref={model.refs[2]} className="flex flex-col gap-[18px] ml-12">
            <h5>3. CORE PROGRAM</h5>
            <span className="flex flex-col gap-[18px] ">
              <p className="ml-3 "><strong>3.1 (a) Commissioning.</strong> You will present an idea or topic for a commissioned Memo
                (“Commissioned Memo”). If We accept this idea, You will create draft(s)
                of the Commissioned Memo and work with our professional in-house editors to edit
                and polish the Commissioned Memo for publication on our Platforms.
              </p>
              <p className="ml-3"><strong>(b) Promotion.</strong> We may require Core Creators to promote their Commissioned Memos
                or Memo’d profile for inclusion in the Core Creator Program. In such events,
                You agree to not make any false or misleading statements in Your promotions
                and shall comply with all applicable laws, rules and regulations 
                (including, without limitation, any third-party privacy policies and terms).
              </p>
            </span>

            <span className=" flex flex-col gap-[18px] ml-3">
              <p><strong>3.2 Core Program Benefits.</strong>
                Core Creators will receive the following Core Program Benefits:
              </p>
              <span className="ml-4">
                3.2.1 Create Commissioned Memos under Your name, or anonymously if You wish, 
                for production and distribution through the Memo’d Platforms.
              </span>
              <span className="ml-4">
                3.2.2 Work with our professional in-house editors,
                who can answer questions and provide suggestions for building a high-impact
                profile on the Platforms.
              </span>
              <span className="ml-4">
                3.2.3 Share and promote Your Commissioned Memos.
              </span> 
              <span className="ml-4">
                3.2.4 You may generate additional revenue by monetizing Your content (refer to the Memo’d Content Monetization Policy for all terms and conditions).
              </span> 
              <span className="ml-4">
                3.2.5 Commissioned Memos may be distinguished from general Creator Memos by a badge icon.
                 This badge indicates to Users that the quality of the Memo has been verified by our in-house editors.
              </span>
              <span className="ml-4">
                3.2.6 Access metrics so that You can view performance data for your Memos and profile,
                 which can help You produce effective content to achieve a greater readership and following.
              </span>
              <span className="ml-4">
                3.2.7 Start building a sticky audience and meeting other like-minded Creators / Users.
              </span>
            </span>
            <span>
              <p className="ml-3"><strong>3.3 Availability. Memo’d reserves the right in its sole discretion to modify,
                terminate, establish, control, and limit any aspect of the Core Program from time
                to time, and without any other notice to You.</strong> Any such change, update, or modification will be 
                effective immediately upon posting. Please review these Core Program Terms periodically to ensure that you continue to
                agree with all of the terms. If You continue to participate in the Core Program
                after those changes, updates, or modifications are in effect, You agree to the
                revised terms.
              </p>
            </span>
          </section>
          <section ref={model.refs[3]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>4. PAYMENT</strong>
              <p className="ml-3 "><strong>4.1 Commission. </strong>Memo’d will pay You per Commissioned Memo within forty-five (45) days from publication of the completed Commissioned Memo. Only Commissioned Memos that are considered acceptable by our in-house editors, and approved prior to any publication on our Platforms, are eligible for any Commission payment.
                Any general (non-Commissioned) Memos published by a Core Program Creator
                are not considered Commissioned Memos and are ineligible for any Commission payment.
              </p>
              <p className="ml-3"><strong>4.2 Payment Processors.</strong> 
              Memo’d uses one or more third party payment processors
              (each, a “Payment Processor”) authorized by Memo’d to collect, process,
               and remit payments on Memo’d’s behalf. You may be subject to the terms,
                conditions, privacy policies, and personal information collection practices
                 of the Payment Processor, in addition to these Core Program Terms.
              </p>
            </span>
            <span>
              <p className="ml-3"><strong>4.3 Additional Fees.</strong> You are responsible for any fees, taxes, duties,
               or charges incurred through services provided to You by Your payment account provider or Payment Processor.
              </p>
            </span>
            <span>
              <p className="ml-3"><strong>4.4 Taxes on Platform Earnings.</strong> You may be liable to pay taxes to
               Your country of residence on Your Platform earnings from the Core Program. 
               Check with Your local tax authorities for detailed guidance.
               Memo’d will collect tax identification information and will charge and withhold the
               applicable taxes if required by law. Notwithstanding the foregoing,
               You will be solely responsible for bearing, reporting, and remitting all income
               or withholding taxes and other government charges which may be due as a result of
               the payments received.
              </p>
            </span>
          </section>
          <section ref={model.refs[4]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>5. INTELLECTUAL PROPERTY</strong>
              
              <p className="ml-3"><strong>5.1 Memo’d Intellectual Property.</strong> The Core Program and Platforms 
                (including all Memo’d content included or accessible within) are the sole property of Memo’d 
                and are protected by intellectual property rights.
                Memo’d will be the sole and exclusive owner of all intellectual property rights in any Commissioned
                Memo that You create in connection with the Core Program (“Commissioned Content”). 
                You understand and agree that the Commissioned Content has been specially ordered and commissioned
                by Memo’d, and all Commissioned Content You produce is a “work made for hire” to the full extent
                permitted by law, with all copyrights in the Commissioned Content owned by Memo’d. 
                You agree that all right, title, and interest in and to such Commissioned Content will be owned,
                immediately upon creation, exclusively by Memo’d. To the extent that any Commissioned Content 
                would not qualify as a work made for hire under applicable law, You hereby assign to Memo’d all 
                of Your right, title and interest in and to any and all Commissioned Content, including without
                limitation all copyright, rights of authorship, and rights of publicity in the Commissioned 
                Content. You hereby waive any applicable moral rights in the Commissioned Content. In the event
                of any termination of this Agreement prior to Your completion of the Commissioned Content,
                the provisions of this Agreement regarding ownership will apply with respect to any portion
                of the Commissioned Content that might have been completed prior to such termination.
                Memo’d will have no obligation to use any of the Commissioned Memos for any purpose, 
                and any decision to use or not use Your Commissioned Memo for the aforementioned purposes
               will be in Memo’d’s sole discretion. Memo’d has no obligation to notify You if it elects
               to use the Commissioned Content in any manner.
              </p>
           </span>
            <span>
              <p className="ml-3"><strong> 5.2 Assistance.</strong> You agree to execute all papers, including copyright assignments,
                and otherwise agree to assist Memo’d as reasonably required at Memo’d’s reasonable
                expense to perfect in Memo’d the right, title and other interest in any Commissioned
                Content You have expressly granted to Memo’d. If Memo’d is unable for any reason,
                after reasonable effort, to secure Your signature on any document needed in connection
                with the actions specified above, You hereby irrevocably designate and appoint Memo’d
                as Your agent and attorney-in-fact, which appointment is coupled with an interest,
                to act for and, on Your behalf, to execute, verify and file any such documents and
                to do all other lawfully permitted acts to further the purposes of the preceding
                paragraph with the same legal force and effect as if executed by You.
              </p>
            </span>
            <span>
              <p className="ml-3"><strong>5.3 License Grant.</strong> Memo’d hereby grants to You a non-exclusive,
                limited license during the term of this Agreement, under all intellectual property
                rights owned or controlled by Memo’d, solely to the extent required for You to participate
                in the Core Program in accordance with these Core Program Terms. With the exception of the foregoing limited license,
                no right, title or interest in or to any intellectual property rights of Memo’d are granted
                to You.
              </p>
            </span>
            <span>
              <p className="ml-3"><strong>5.4 Release; Right of Publicity. </strong>
                You grant to Memo’d the right to use Your name, voice, image, likeness,
                and biographical information You provide to Memo’d (collectively, “Attributes”)
                in connection with the distribution, exhibition, marketing, and other use of the
                Commissioned Content. You release Memo’d, its affiliates, and their respective assigns,
                licensees, and successors from any claims that may arise regarding the use of Your
                Attributes, including any claims of defamation, invasion of privacy, or infringement of moral
                rights, rights of publicity, or copyright.
              </p>
            </span>
            <span>
            
            </span>
          </section>
          <section ref={model.refs[5]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>6. TERMINATION</strong>
              <p className="ml-3">The term of this agreement shall begin upon Your acceptance of Invitation
                to participate in the Core Program. This Agreement will remain in effect,
                unless terminated as set forth below.
              </p>
            </span>
          </section>
          <section ref={model.refs[6]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>7. PARTIES’ RELATIONSHIP</strong>
              <p className="ml-3"> Your participation in the Core 
                Program does not imply any agency, representation,
                sponsorship, or endorsement between Memo’d and You. Your participation in the Core
                Program is voluntary and at will. Nothing in Your participation in the Core Program
                or this Agreement should be construed to create a partnership, joint venture, or
                employer-employee relationship.
                </p>
             </span>
          </section>
          <section ref={model.refs[7]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>8. COMMUNICATIONS</strong>
              <p className="ml-3">
                Subject to the Privacy Policy, you may receive promotional email communications
                regarding the Services from Memo’d from time to time. If You would like to unsubscribe
                from these promotional emails, find and click the unsubscribe button at the bottom of
                the promotional emails.
              </p>

            </span>
          </section>
          <section ref={model.refs[8]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>9. CONFIDENTIALITY</strong>
              <p className="ml-3">
               Any information about Memo’d, its affiliates, or its products,
               including the Platform and the Services, that is made available to You through
               the Programs, including but not limited to this Agreement, that is not otherwise
                publicly available is Memo’d’s confidential information (“<strong>Confidential Information</strong>”).
               You agree not to disclose any Confidential Information to any third party under any
               circumstance, unless previously approved in writing by Memo’d.
              </p>
            </span>

          </section>
          <section ref={model.refs[9]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>10.REPRESENTATIONS AND WARRANTIES</strong>
              <p className="ml-3">You are solely responsible for your Posted Content and the consequences of posting it.
                You should only provide Content that you are comfortable sharing with others.
                By posting Your Posted Content, You represent, and warrant that:
              </p>
              <div className="flex flex-col gap-[18px] ml-3">
                <p>10.1 Your Posted Content does not and will not (i) infringe, violate, or misappropriate
                  any third-party’s and/or intellectual property, privacy, or proprietary right, (ii) defame,
                  harass, bully, or impersonate any other person, or (iii) violate any other law, rule, or regulation;
                </p>
                <p>10.2 You have, or have obtained, all rights, licenses, consents, permissions, power and/or authority
                  necessary to grant the rights granted herein for any Posted Content that You submit, post,
                  or display on or through the Services;
                </p>

                <p>
                  10.3
                  Your Posted Content does not contain material subject to copyright or other proprietary
                  rights, unless You have necessary permission or are otherwise legally entitled to post
                  the material and to grant Memo’d the license described herein;
                </p>
                <p>10.4
                  Your Posted Content does not violate these Terms or Memo’d’s Terms of Service,
                  including those additional terms and policies incorporated by reference; and
                </p>
                <p>10.5 Unless You have received prior written authorization, your Posted Content specifically
                  does not contain any pre-release or non-public beta feature or content or any
                  Confidential Information of Memo’d or confidential information of third parties.
                </p>
              </div>
            </span>
          </section>
          <section ref={model.refs[10]} className="flex flex-col gap-[18px] ml-12">
            <strong>11. ACCOUNT SUSPENSION/TERMINATION; FORFEITURE; WITHDRAWAL</strong>
            <span className="flex flex-col gap-[18px] ml-3">
              <p><strong>11.1 Account Suspension or Termination.</strong> We may suspend or terminate Your account or cease providing You with all or part of the Services
                at any time for any or no reason, including, but not limited to, if we reasonably believe:
                (i) You have violated these Terms or the Terms of Service; (ii) You create risk or possible
                legal exposure for us; (iii) Your account should be removed due to unlawful conduct; (iv)
                Your account should be removed due to prolonged inactivity; or (v) our provision of the Services
                to You is no longer commercially viable. We will make reasonable efforts to notify You by the email
                address associated with Your account or the next time You attempt to access Your account, depending
                on the circumstances.
              </p>
              <p ><strong>11.2 Forfeiture.</strong> Without limiting Our other rights or remedies, if We believe You have violated
                these Terms or the Terms of Service, We may determine that all or any portion 
                of the remaining platform earnings balance in Your account that you may otherwise
                have been entitled to receive will be void and forfeited.
              </p>
              <p><strong>11.3 Withdrawal.</strong> You may withdraw Your participation in the Core Program by providing Your in-house
                editor with written notice of Your Intent to Withdraw. An electronic communication or e-mail
                (“Electronic Notice”) shall be deemed written notice for purposes of this Section 11.3 if sent 
                to the e-mail address specific to Your assigned in-house editor or <a className="text-blue-700 hover:underline" 
                href="mailto:support@memod.com">support@memod.com</a>.
              </p>
            </span>
          </section>
          <section ref={model.refs[11]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>12. DISCLAIMER</strong>
              <p className="ml-3">Your access to and use of the Services or any Posted Content are at Your own risk.
                You understand and agree that the Services are provided to you on an “AS IS” and “AS AVAILABLE”
                basis. The “Memo’d Entities” refers to Memo’d, its related companies, affiliates, officers,
                directors, employees, agents, representatives, partners, and licensors. Without limiting the foregoing, 
                to the maximum extent permitted under applicable law, THE MEMO’D ENTITIES DISCLAIM ALL WARRANTIES                  AND CONDITIONS, WHETHER EXPRESS OR IMPLIED, OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                OR NON-INFRINGEMENT. The Memo’d Entities make no warranty or representation and disclaim all responsibility
                and liability for: (i) the completeness, accuracy, availability, timeliness, security or reliability
                of the Services or any Posted Content; (ii) any harm to Your computer system, loss of data, or other harm that
                results from access to or use of the Services or any Posted Content; (iii) the deletion of, or the failure to store or to transmit,
                any Posted Content and other communications maintained by the Services; and (iv) whether the Services will meet Your requirements or be available on an uninterrupted,
                secure, or error-free basis. No advice or information, whether oral or written, obtained from the Memo’d Entities or through the Services, will create any warranty or 
                representation not expressly made herein.
              </p>
            </span>
          </section>
          <section ref={model.refs[12]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>13. LIMITATION OF LIABILITY</strong>
              <p className="ml-3">TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE MEMO’D ENTITIES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
              CONSEQUENTIAL OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA,
              USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM (i) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICES; 
              (ii) ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE SERVICES, INCLUDING WITHOUT LIMITATION, ANY DEFAMATORY, OFFENSIVE OR ILLEGAL 
              CONDUCT OF OTHER USERS OR THIRD PARTIES; (iii) ANY CONTENT OBTAINED FROM THE SERVICES; OR (iv) UNAUTHORIZED ACCESS, USE OR ALTERATION 
              OF YOUR TRANSMISSIONS OR CONTENT. IN NO EVENT SHALL THE AGGREGATE LIABILITY OF THE MEMO’D ENTITIES EXCEED THE GREATER OF ONE HUNDRED U.S. 
              DOLLARS (U.S. $100.00) OR THE AMOUNT YOU PAID MEMO’D, IF ANY, IN THE PAST SIX MONTHS FOR THE SERVICES GIVING RISE TO THE CLAIM. THE LIMITATIONS OF 
              THIS SECTION SHALL APPLY TO ANY THEORY OF LIABILITY, WHETHER BASED ON WARRANTY, CONTRACT, STATUTE, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE, AND WHETHER OR NOT THE MEMO’D 
              ENTITIES HAVE BEEN INFORMED OF THE POSSIBILITY OF ANY SUCH DAMAGE, AND EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.
              </p>
            </span>
          </section>
          <section ref={model.refs[13]} className="flex flex-col gap-[18px] ml-12">
            <span className="flex flex-col gap-[18px]">
              <strong>14. ASSIGNMENT</strong>
              <p className="ml-3">Creator will not assign, sell, transfer, delegate or otherwise dispose of, whether voluntarily
                or involuntarily, by operation of law or otherwise, this Agreement or any or its rights or obligations
                under this Agreement without Memo’d’s prior written consent. Memo’d may freely assign this Agreement or any 
                of its rights or obligations under this Agreement without the consent of Creator.
              </p>
            </span>
          </section>
          <section ref={model.refs[14]} className="flex flex-col gap-[18px] ml-12">
            <strong>15. GENERAL</strong>
            <span className="flex flex-col gap-[18px] ml-3">
              <span className=" ml-3">
                <strong>15.1 Applicable Law.</strong>
                <p className="ml-3">Any and all disputes and causes of action arising out of or connected with the Programs and the enforceability
                  of these Terms, shall be governed by and construed in accordance with the laws of the state of California without
                  regard to its conflict of law provisions. To the extent that any lawsuit is permitted under this Agreement, You and Memo’d
                  hereby expressly consent to the personal and exclusive jurisdiction and venue of the state and federal courts located in the
                  City and County of San Francisco, California, and waive any objection as to inconvenient forum.
                </p>
              </span>
              <span className=" ml-3">
                <strong>15.2 Entire Agreement</strong>
                <p className="ml-3">These, including the Terms of Service, Privacy Policy and any other terms and conditions
                  which are incorporated herein or might accompany the Programs or applicable Service,
                  constitute the entire agreement between You and Memo’d and shall govern the use of the
                  Programs, superseding any prior agreement between You and Memo’d with respect to the Programs.
                  You may also be subject to additional terms and conditions that may apply when You use or purchase
                  certain other Memo’d Services, affiliate Services, third-party content, or third-party software.
                </p>
              </span>
              <span className="ml-3">
                <strong>15.3 Waiver; Severability.</strong>
                <p className="ml-3">At any time, should Memo’d fail to exercise or enforce any right of provision of these
                  Terms, such failure shall not constitute a waiver of such right or provision. If any 
                  provision of these Terms is found by a court of competent jurisdiction to be invalid,
                  the parties nevertheless agree that the court should endeavor to give effect to the
                  parties’ intentions as reflected in the provision, and the other provisions of the 
                  Terms remain in full force and effect.
                </p>
              </span>
              <span className="ml-3">
                <strong>15.4 No Right of Survivorship; Non-Transferability.</strong>
                <p className="ml-3">You acknowledge and agree that Your account is non-transferable and any rights to Your
                  account and/or contents within Your account shall terminate upon Your death.
                </p>
              </span>
              <span className="ml-3">
                <strong>15.5 Changes to Core Program Terms.</strong>
                <p className="ml-3">Memo’d may, from time to time, change these Terms.
                  Such revisions shall be effective immediately. Your continued participation in the
                  Program(s) indicates Your acceptance of such changes, and as such, Your frequent 
                  review of this Agreement and policies currently in effect. Should You not agree to any
                  updated, revised or modified terms, You must stop using the provided Services forthwith.
                </p>
              </span>
              <span className="ml-3">
                <strong >15.6 Assignment.</strong>
                <p className="ml-3">We may assign our agreement with You to any affiliated company or to any entity
                  that succeeds to all or substantially all of our business or assets related to
                  the Programs. Neither these Terms nor any right, obligation, or remedy hereunder
                  is assignable, transferable, delegatable, or sublicensable by You except with our
                  prior written consent, and any attempted assignment, transfer, delegation, or sublicense
                  shall be null and void.
                </p>
              </span>
              <span className=" ml-3">
                <strong>15.7 Electronic Communications.</strong>
                <p className="ml-3">When You use the Services, or send e-mails, text messages, and other communications
                  from Your computer or mobile device to us, You may be communicating with us electronically.
                  You consent to receive communications from Memo’d electronically, such as e-mails, texts, 
                  mobile push notices, or notices, and messages through the Services, and you can retain copies of these 
                  communications for your records. You agree that all agreements, notices, disclosures, and other communications 
                  that we provide to You electronically satisfy any legal requirement that such communications be in writing.
                </p>
                <p className="ml-3 mt-4">Last updated: February 2023</p>
              </span>
            </span>
          </section>
        </article>

      </main>
    </LegalLayout>
  );
}
